import React from 'react';
import PropTypes from 'prop-types';
import { Doughnut } from 'react-chartjs-2';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
    graphContainer: {
        position: 'relative',
        width: '100%',
    },
});


const DoughnutGraph = ({
    classes,
    theme,
    graphData,
}) => {
    const graphOptions = {
        tooltips: {
            mode: 'index',
            intersect: false,
        },
        animation: {
            duration: 0,
        },
        hover: {
            mode: 'average',
            intersect: true,
        },
        legend: {
            display: true,
            position: 'bottom',
            onClick: () => {},
            labels: {
                usePointStyle: true,
                fontColor: theme.palette.text.secondary,
            },
        },
    };

    return (
        <div className={classes.graphContainer}>
            <Doughnut height={150} data={graphData} options={graphOptions} />
        </div>
    );
};

DoughnutGraph.propTypes = {
    classes: PropTypes.objectOf(PropTypes.any).isRequired,
    theme: PropTypes.objectOf(PropTypes.any).isRequired,
    graphData: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withStyles(styles, { withTheme: true })(DoughnutGraph);
